import { CellContext } from '@tanstack/react-table';
import { MessageStatusDto } from '@/features/dashboard/messages/types/MessageStatusDto.ts';
import {
  mapToUserMessageStatus,
  userMessageStatusTableConfig,
} from '@/features/dashboard/messages/types/UserMessageStatus.utils.ts';
import { EnumValueCell } from '@/components/table/_fieldDefinitions/_base/EnumValueCell.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const messageStatusFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as MessageStatusDto | null | undefined;
  if (!value) return <EmptyValue />;

  const config = userMessageStatusTableConfig[mapToUserMessageStatus(value)];
  if (!config) return <EmptyValue />;

  return <EnumValueCell config={config} />;
};
